import { ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { ProfileBackgroundCheckCard, SlideoutBackgroundCheckCard } from '@/ui/features/accounts';
import { LicenseStatus } from '@juvare/credentialing/backend/extraTypes';
import {
    ProfileOigVerificationCard,
    ProfileOigVerificationCardProps,
    SlideoutOigVerificationCard,
} from '@juvare/credentialing/ui/features/credentialing-verification';
import { Box, Grid } from '@mui/material';
import React from 'react';

export interface AdditionAccountHeaderContentProps extends ProfileOigVerificationCardProps {
    account: ExtendedAccountData;
    cardStyle?: 'profile' | 'slideout';
}

export const AdditionAccountHeaderContent: React.FC<AdditionAccountHeaderContentProps> = ({ account, cardStyle }) => {
    const isSlideout = cardStyle === 'slideout';
    const OigVerificationCard = isSlideout ? SlideoutOigVerificationCard : ProfileOigVerificationCard;
    const BackgroundCheckCard = isSlideout ? SlideoutBackgroundCheckCard : ProfileBackgroundCheckCard;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: { xs: 3, sm: 0 } }}>
            <Grid container spacing={1} sx={{ maxWidth: { sm: isSlideout ? undefined : '308px' }, ml: { sm: isSlideout ? 0 : 3 } }}>
                <Grid item xs={12}>
                    <OigVerificationCard oigStatus={account.oigStatus as LicenseStatus} />
                </Grid>
                <Grid item xs={12}>
                    <BackgroundCheckCard backgroundCheckStatus={account.primaryBackgroundCheckStatus} />
                </Grid>
            </Grid>
        </Box>
    );
};
